export default __webpack_public_path__ + "static/media/conversion_table.e20888b9.pdf";